<template>
  <li class="park_activities_item">
    <router-link :to="`/garden_activity_details?code=${item.code}&id=${item.id}`" target="_blank" class="office_space_item_a">
      <img v-lazy="item.coverPath" :key="item.coverPath"/>
      <router-link
        target="_blank"
        :to="`/investment_info_park_detail/office_list?id=${item.incubator_id}`"
        class="park_name elip"
      >{{item.incubator_name}}</router-link>
      <div class="office">
        <div class="l elip">{{ item.name }}</div>
      </div>
      <h4>{{ item.start_date }}</h4>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.park_activities_item {
  width: 224px;
  margin: 0 19px 20px 0;
  .office_space_item_a {
    display: flex;
    flex-direction: column;
    img {
      width: 224px;
      height: 167px;
      border-radius: 4px;
    }
    .park_name {
      height: 26px;
      line-height: 26px;
      color: #343434;
      font-size: 12px;
      margin-top: 12px;
    }
    .park_name:hover {
      color: #4c84ff;
    }
    .office {
      height: 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .l {
        font-size: 16px;
        font-weight: bold;
        color: #343434;
        max-width: 250px;
      }
      .r {
        color: #ff4e5a;

        font-size: 14px;
        span {
          font-size: 18px;

          font-weight: bold;
        }
      }
    }
    & > h4 {
      height: 26px;
      line-height: 26px;
      color: #9a9a9a;
    }
  }
}
.park_activities_item:nth-child(5n){
  margin-right: 0;
}
</style>
